import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const GalleryPreview = () => {
  // Real project photos - optimized WebP images
  const galleryItems = [
    {
      image: '/gallery/bathroom-luxury-spa.webp',
      title: 'Luxury Spa Bathroom',
      category: 'Bathroom Renovation',
      alt: 'Calgary luxury bathroom renovation with terrazzo tile and spa features'
    },
    {
      image: '/gallery/fireplace-gold-trim.webp',
      title: 'Elegant Gold-Trim Fireplace',
      category: 'Custom Fireplace',
      alt: 'Custom fireplace Calgary with marble surround and gold accents'
    },
    {
      image: '/gallery/bathroom-herringbone.webp',
      title: 'Black Herringbone Shower',
      category: 'Bathroom Renovation',
      alt: 'Calgary bathroom renovation with black herringbone tile shower'
    },
    {
      image: '/gallery/custom-arched-bar.webp',
      title: 'Custom Arched Bar',
      category: 'Custom Features',
      alt: 'Custom wet bar Calgary with arched design and built-in shelving'
    },
    {
      image: '/gallery/bathroom-terrazzo-shower.webp',
      title: 'Terrazzo Rainfall Shower',
      category: 'Premium Finishes',
      alt: 'Calgary bathroom renovation with terrazzo shower and rainfall head'
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-[#f8f9fa]" data-testid="gallery-preview-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4">
              Our Work
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold text-[#0f172a]">
              Real Projects Completed in Calgary
            </h2>
          </div>
          <Link
            to="/gallery"
            className="group flex items-center gap-2 text-[#0f172a] font-medium mt-6 md:mt-0 hover:text-[#c5a059] transition-colors"
            data-testid="gallery-view-all-link"
          >
            View All Projects
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Gallery Grid - Bento Style */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {/* Large featured image */}
          <div
            className="gallery-item relative col-span-2 row-span-2 aspect-square md:aspect-auto overflow-hidden group cursor-pointer"
            data-testid="gallery-item-featured"
          >
            <img
              src={galleryItems[0].image}
              alt={galleryItems[0].alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-[#0f172a]/0 group-hover:bg-[#0f172a]/60 transition-all duration-300 flex items-end p-4 md:p-6">
              <div className="transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-[#c5a059] text-xs uppercase tracking-wider mb-1">
                  {galleryItems[0].category}
                </p>
                <p className="text-white font-heading text-lg font-medium">
                  {galleryItems[0].title}
                </p>
              </div>
            </div>
          </div>

          {/* Other gallery items */}
          {galleryItems.slice(1).map((item, index) => (
            <div
              key={index}
              className="gallery-item relative aspect-square overflow-hidden group cursor-pointer"
              data-testid={`gallery-item-${index + 1}`}
            >
              <img
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#0f172a]/0 group-hover:bg-[#0f172a]/60 transition-all duration-300 flex items-end p-4 md:p-6">
                <div className="transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <p className="text-[#c5a059] text-xs uppercase tracking-wider mb-1">
                    {item.category}
                  </p>
                  <p className="text-white font-heading text-lg font-medium">
                    {item.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Strong CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 bg-[#0f172a] text-white px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-[#1e293b] transition-colors"
            data-testid="gallery-preview-cta"
          >
            Get Your Free Estimate
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GalleryPreview;
